export const theme: { [key: string]: string } = {
  'menu-background': 'linear-gradient(90deg, rgba(81, 12, 13, 1) 0%, rgba(101, 61, 96, 1) 100%)',
  buttonBackgroundColor: '#404040',
  buttonTextColor: '#fff',
  primaryBackground: '#A9A9A9FF',
  primary01: 'rgba(255, 0, 211, 1)',
  primary02: 'rgba(180, 0, 153, 1)',
  primary01Hover: 'rgba(255, 255, 255, 0.8)',
  primary01Pressed: 'rgba(255, 255, 255, 0.6)',
  primary01Disabled: 'rgba(224, 224, 224, 1)',
  primary02Hover: 'rgba(180, 0, 153, 0.8)',
  primary02Disabled: 'rgba(68, 0, 65, 1)',
  blurBackgroundColorContinueWatching: 'rgba(15, 1, 37, 0.2)',
  neutral08WithOpacity: 'rgba(15, 1, 37, 0.8)',
  primaryHover: 'rgba(180, 0, 0, 0.8)',
  primaryPressed: 'rgba(180, 0, 0, 1)',
  primaryDivider: 'rgba(255, 0, 0, 1)',
  inputRequiredAsterisk: 'rgba(180, 0, 0, 1)',
  primaryButtonDisabled: 'rgba(240, 240, 240, 1)',
  primaryColorTextButton: 'rgba(180, 0, 0, 1)',
  whiteButton: 'rgba(255, 255, 255, 1)',
  whiteButtonHover: 'rgba(255, 255, 255, 0.8)',
  whiteButtonActive: 'rgba(255, 255, 255, 1)',
  secondaryPurpleBackground: 'rgba(68, 0, 0, 1)',
  genresBackground: 'rgba(105, 0, 0, 1)',
  genresBorder: 'rgba(128, 128, 128, 1)',
  dropdownBackground: 'rgba(56, 51, 65, 1)',
  genericRedeemBackground: 'rgba(205, 205, 205, 1)',
  primaryButtonDisabledText: 'rgba(179, 179, 179, 1)',
  neutral01: 'rgba(255, 255, 255, 1)',
  neutral03: '#e0e0e0',
  neutral04: '#d0d0d0',
  neutral05: '#c0c0c0',
  neutral06: '#808080',
  neutral07: '#404040',
  neutral08: '#404040',
  neutral09: 'rgba(6, 0, 17, 1)',
  neutral10: 'rgba(6, 0, 17, 1)',
  neutral11: 'rgba(255, 255, 255, 0.3)',
  neutral12: 'rgba(56, 51, 65, 1)',
  'progress-bar-background-color': 'rgba(255, 255, 255, 0.4)',
  'player-progress-bar-background-color': 'rgba(255, 255, 255, 0.3)',
  tertiary28: '#fce6ea',
  tertiary31: '#e7516d',
  tertiary48: '#dfeaf9',
  tertiary51: '#548ee9',
  text01: '#303030',
  text02: 'rgb(56, 56, 56)',
  text03: 'rgb(132, 132, 132)',
  text04: 'rgb(180, 180, 180)',
  text05: '#fff',
  text06: 'rgb(120, 117, 124)',
  text07: 'rgb(255, 255, 255)',
  text08: 'rgba(255, 255, 255, 0.12)',
  text09: 'rgba(110, 110, 110, 1)',
  text10: 'rgb(169, 169, 169)',
  semanticWarning: '#fba63a',
  semanticError: 'rgba(180, 0, 0, 1)',
  semanticSuccess: '#1bb096',
  semanticInfo: '#0f48d6',
  tertiary33: '#bb0a1b',
  visitedSecondaryLink: '#c0c0c0',
  inputBackground: 'rgba(6, 0, 17, 1)',
  inputBorder: '#b3b3b3',
  black: '#000000',

  btnBackground: 'rgba(180, 0, 0, 1)',
  btnBackgroundHover: 'rgb(215,0,0)',
  btnBackgroundPressed: 'rgba(180, 0, 0, 1)',
  btnText: 'white',

  btn2Background: 'rgba(255, 255, 255, 1)',
  btn2BackgroundHover: 'rgba(255, 255, 255, 0.8)',
  btn2BackgroundPressed: 'rgba(255, 255, 255, 1)',
  btn2Text: '#000',

  btnBackgroundDisabled: 'rgba(179, 179, 179, 1)',
  btnTextDisabled: 'gray',
};
